<!-- Keep in sync with the SSR footer: content is data-driven from
     steve/config.py FOOTER_TAGLINE/FOOTER_COLUMNS and rendered by
     steve/templates/partials/_footer.html — mirror any change here there. -->
<template>
<footer class="site-footer">
    <div class="foot-grid">
        <div class="foot-brand">
            <router-link to="/" class="brand">
                <div class="brand-mark"></div>
                <div class="brand-text">ASO<em>Radar</em></div>
            </router-link>
            <p>Reviews intelligence for App Store and Google Play. REST API, official SDKs, pay per request.</p>
        </div>
        <div class="foot-col">
            <h5>// Product</h5>
            <ul>
                <li><router-link to="/docs">Endpoints</router-link></li>
                <li><router-link to="/pricing">Pricing</router-link></li>
                <li><router-link to="/mcp">MCP server</router-link></li>
                <li><router-link to="/startapp">STARTAPP</router-link></li>
                <li><a href="https://www.npmjs.com/package/asoradar" target="_blank" rel="noopener noreferrer">JS SDK &middot; npm</a></li>
                <li><a href="https://pypi.org/project/asoradar/" target="_blank" rel="noopener noreferrer">Python SDK &middot; PyPI</a></li>
                <li><router-link to="/changelog">Changelog</router-link></li>
                <li><router-link to="/status">Status</router-link></li>
            </ul>
        </div>
        <div class="foot-col">
            <h5>// Station</h5>
            <ul>
                <li><router-link to="/help/about">About</router-link></li>
                <li><router-link to="/help">Help Center</router-link></li>
                <li><router-link to="/blog">Blog</router-link></li>
                <li><router-link to="/help/affiliate">Affiliate program</router-link></li>
                <li><a :href="`mailto:${$state.siteEmail}`">{{ $state.siteEmail }}</a></li>
                <li><a :href="`https://t.me/${$state.siteTgSupport}`" target="_blank" rel="noopener noreferrer">Telegram support</a></li>
            </ul>
        </div>
        <div class="foot-col">
            <h5>// Legal</h5>
            <ul>
                <li><router-link to="/help/terms">Terms of service</router-link></li>
                <li><router-link to="/help/privacy">Privacy policy</router-link></li>
                <li><router-link to="/help/refund">Refund policy</router-link></li>
            </ul>
        </div>
    </div>
    <div class="foot-bottom">
        <span>&copy; {{ year }} ASORadar Station ASR-001 &middot; All frequencies reserved</span>
        <span>BUILD {{ $state.version }} &middot; OPS NOMINAL &middot; <span class="live-dot"></span>LIVE</span>
    </div>
</footer>
</template>

<script>
export default {
    computed: {
        year() { return new Date().getFullYear() },
    },
}
</script>
